'use strict';

const tracking = require('dibs-tracking');

module.exports = {
    trackOpen() {
        tracking.trackEvent({
            category: 'trade program education',
            action: 'trade welcome message',
            label: 'trade welcome docked message displayed'
        });
    },

    trackClose() {
        tracking.trackEvent({
            category: 'trade program education',
            action: 'trade welcome message',
            label: 'trade welcome docked message closed'
        });
    },

    trackExpand() {
        tracking.trackEvent({
            category: 'trade program education',
            action: 'trade welcome message',
            label: 'trade welcome docked message expanded'
        });
    }
};



// WEBPACK FOOTER //
// ./assets/js/global/components/TradeWelcomeMessage/tradeWelcomeMessageTracking.es.js